// @bitacorapro/postventa-taxonomy — el CONTENIDO del catálogo de
// clasificación postventa v2.1-mvp (ADR-0129). Los shapes y el
// mecanismo (validación, severidad derivada, matriz-como-ranking)
// viven en @bitacorapro/core-engine/taxonomy; este paquete es datos
// versionados, inyectados por las apps igual que el recipe registry.
//
// Consumidores previstos: core-api (validación de membership en
// POST /findings/:id/classification + estampado de taxonomy_version),
// ai-svc (render del prompt del clasificador, ola 3), web-dashboard
// (labels del modal de asignación — import directo de build, jamás por
// el payload de recipe: el propietario nunca ve códigos, invariante 8).
import { taxonomyCatalogSchema, } from "@bitacorapro/core-engine";
import { ELEMENTOS } from "./elementos.js";
import { ESPECIALIDADES } from "./especialidades.js";
import { MATRIZ_ESPERADA } from "./matriz.js";
import { PROCEDENCIAS } from "./procedencias.js";
import { RECINTOS } from "./recintos.js";
import { REGLAS_DESEMPATE } from "./desempate.js";
import { TIPOS_FALLA } from "./tipos-falla.js";
import { TAXONOMY_VERSION_CURRENT } from "./version.js";
export { SOURCE_XLSX_VERSION, TAXONOMY_VERSION_CURRENT } from "./version.js";
export { RECINTOS } from "./recintos.js";
export { ELEMENTOS } from "./elementos.js";
export { ESPECIALIDADES } from "./especialidades.js";
export { TIPOS_FALLA } from "./tipos-falla.js";
export { PROCEDENCIAS } from "./procedencias.js";
export { REGLAS_DESEMPATE } from "./desempate.js";
export { MATRIZ_ESPERADA } from "./matriz.js";
// Parse (no cast) en el momento del import: un catálogo malformado
// revienta el build/boot, jamás llega a runtime a medias.
export const POSTVENTA_TAXONOMY_2_1_MVP = taxonomyCatalogSchema.parse({
    version: TAXONOMY_VERSION_CURRENT,
    recintos: RECINTOS,
    elementos: ELEMENTOS,
    especialidades: ESPECIALIDADES,
    tiposFalla: TIPOS_FALLA,
    procedencias: PROCEDENCIAS,
    reglasDesempate: REGLAS_DESEMPATE,
    matrizEsperada: MATRIZ_ESPERADA,
});
/** Keyed por versión para que una fila histórica decodifique contra la
 *  versión con que fue estampada (una revisión trimestral agrega una
 *  entrada nueva, jamás edita la anterior). */
export const taxonomyRegistry = new Map([
    [TAXONOMY_VERSION_CURRENT, POSTVENTA_TAXONOMY_2_1_MVP],
]);
//# sourceMappingURL=index.js.map